import dayjs from 'dayjs';
import { z } from 'zod';

export const DateRangeZodType = z.tuple([
  z.custom<dayjs.Dayjs | null>(
    (val) => val === null || dayjs.isDayjs(val),
    'Expected a dayjs object or null'
  ),
  z.custom<dayjs.Dayjs | null>(
    (val) => val === null || dayjs.isDayjs(val),
    'Expected a dayjs object or null'
  ),
]);

export const SpreadSheetColumnSchema = z.object({
  columnName: z.string(),
  columnDescription: z.string().nullable().optional(),
  valueName: z.string(),
  name: z.string(),
  isCanned: z.boolean().catch(false),
  useInReport: z.boolean().catch(false),
  showInColumnPicker: z.boolean().catch(false),
  type: z.string().optional(),
  requiredInReport: z.boolean().catch(false),
  requiredInBulkOps: z.boolean().catch(false),
});
